import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { InfoTooltip } from '@/components/InfoTooltip';
import styles from '../DashboardOverviewNew.module.scss';

export const DonutCard = ({
  className,
  isLoading = false,
  title,
  tooltip,
  chartSize,
  innerRadius,
  outerRadius,
  segments,
  centerValue,
  centerLabel,
  footerLabel,
  footerTo,
  onFooterClick,
  showLegend = true,
}) => {
  const centerLabelLines = Array.isArray(centerLabel)
    ? centerLabel
    : [centerLabel];

  return (
    <div
      className={className}
      style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
    >
      <div className={styles.cardHeader}>
        <div className={styles.cardTitleGroup}>
          <span className={styles.cardTitle}>{title}</span>
          {tooltip && <InfoTooltip title={title} {...tooltip} />}
        </div>
      </div>

      <div className={styles.donutWrapper}>
        <div className={styles.donutChartArea}>
          <ResponsiveContainer width={chartSize} height={chartSize}>
            <PieChart>
              <Pie
                data={segments}
                cx="50%"
                cy="50%"
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                dataKey="value"
                startAngle={90}
                endAngle={-270}
                strokeWidth={0}
              >
                {segments.map((seg) => (
                  <Cell key={seg.name} fill={seg.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div className={styles.donutCenter}>
            <div className={styles.donutCenterValue}>{centerValue}</div>
            {centerLabelLines.map((line) => (
              <div key={line} className={styles.donutCenterLabel}>
                {line}
              </div>
            ))}
          </div>
        </div>

        {showLegend && (
          <div className={styles.donutLegend}>
            {segments.map((seg) => (
              <div key={seg.name} className={styles.legendItem}>
                <div
                  className={styles.legendDot}
                  style={{ backgroundColor: seg.color }}
                />
                <span className={styles.legendRowName}>{seg.name}</span>
                <span className={styles.legendRowValue}>
                  {seg.displayValue}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>

      {footerTo && (
        <Link to={footerTo} className={styles.viewLink}>
          {footerLabel} <FiArrowRight size={13} />
        </Link>
      )}
      {!footerTo && onFooterClick && (
        <button className={styles.viewLink} onClick={onFooterClick}>
          {footerLabel} <FiArrowRight size={13} />
        </button>
      )}
    </div>
  );
};
